<template>
    <AuthLayout :imageSrc="currentImage" :layoutType="step === 2 ? 'full' : ''">
        <div class="flex justify-content-center align-items-center w-full">
            <Card class="motivation-card" :style="step === 2 ? 'max-width: 80%' : ''">
                <template #content>
                    <div class="flex flex-column align-items-center justify-content-center w-full">
                        <RegistrationView v-if="step === 1" @registration-success="setRegistrationData" />
                        <PaymentPlansView v-if="step === 2" @package-selected="setPackageInfo" />
                    </div>
                </template>
            </Card>
        </div>
    </AuthLayout>
</template>

<script setup>
import { ref, defineProps, watch, onMounted, computed } from 'vue';
import AuthLayout from "@/layout/AuthLayout.vue";
import RegistrationView from "@/components/RegistrationComponent.vue"
import PaymentPlansView from '@/components/instituteOnboardingFlow/instituteOnboardingPaymentPlansPage.vue';
import step1Img from "@/assets/Images/image1.png";
import { useAuthStore } from "@/stores/authStore";
import { notifyContrast, notifySuccess, notifyError } from '@/utils/notification';
import { updateInstitute, fetchInstituteProfile } from '@/api/institutes';
import Card from 'primevue/card';
import { useRouter } from 'vue-router';

const authStore = useAuthStore();
const router    = useRouter();

const props = defineProps({
    registrationData: {
        type: Object,
        required: false,
    }
});

const localData       = ref(props.registrationData);
const step            = ref(1);
const alreadyLoggedIn = ref(false);

onMounted(async () => {
    if (authStore.user) {
        alreadyLoggedIn.value = true;
        try {
            const response  = await fetchInstituteProfile();
            const freshUser = response.data.data;
            authStore.user  = { email: authStore.user.email, ...freshUser };
            localData.value = { ...freshUser };
        } catch { /* use cached user */ }

        step.value = 2;
        notifyContrast("Complete Your Onboarding", "Hi " + authStore.user.username + "! It looks like you didn't finish setting up your profile. Please complete your onboarding process.");
    }
});

watch(
    () => props.registrationData,
    (newVal) => { localData.value = newVal; }
);

const setRegistrationData = (data) => {
    localData.value       = data;
    step.value            = 2;
    alreadyLoggedIn.value = true;
};

const setPackageInfo = async (pkg) => {
    try {
        const packageId = pkg?.id || authStore.user?.subscriptionPackage || null;
        await updateInstitute({ subscriptionPackage: packageId, registrationCompleted: true });
        if (authStore.user) {
            authStore.user.subscriptionPackage   = packageId;
            authStore.user.registrationCompleted = true;
        }
        notifySuccess("Welcome to iLearn'd!", "Your profile is ready. Let's get started!");
        router.push("/institution_dashboard");
    } catch (error) {
        notifyError("Error", "Failed to complete registration. Please try again.");
    }
};

const currentImage = computed(() => {
    switch (step.value) {
        case 1: return step1Img;
        default: return "";
    }
});
</script>

<style scoped>
.motivation-card {
    width: 100%;
    border: none;
    box-shadow: none;
    max-width: 700px;
}
</style>
